export function getStoredAccessToken() {
  if (typeof window === 'undefined') return '';

  const storageKeys = ['accessToken', 'token'];
  for (const key of storageKeys) {
    const value = window.localStorage.getItem(key);
    if (value) return value.replace(/^Bearer\s+/i, '').trim();
  }

  const cookieKeys = ['accessToken', 'token', 'jwt', 'authToken'];
  const cookies = document.cookie ? document.cookie.split(';') : [];

  for (const key of cookieKeys) {
    const matchedCookie = cookies
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.startsWith(`${key}=`));

    if (matchedCookie) {
      const cookieValue = decodeURIComponent(matchedCookie.split('=').slice(1).join('=')).trim();
      return cookieValue.replace(/^Bearer\s+/i, '').trim();
    }
  }

  return '';
}

export function getAuthHeaders() {
  const token = getStoredAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
